import { StringSchema } from 'yup'

function nullableValidString(this: StringSchema, message: string) {
  return this.test('nullableValidString', message, (value) => {
    const validations = [this.atLeastOneCharacter(), this.atLeastOneNumber(), this.min(8)]

    return !value || validations.every((validation) => validation.isValidSync(value))
  })
}

export default nullableValidString
